<script lang="ts" setup>
import { ref } from 'vue'
import { BanknotesIcon, CurrencyEuroIcon, DocumentCheckIcon, ScaleIcon, VariableIcon } from '@heroicons/vue/24/outline'

const kpiNavigation = ref([
  { name: '7 derniers jours' },
  { name: '30 derniers jours' },
  { name: 'Depuis toujours' },
]);
const currentKpiIndex = ref(0);

const stats = [
  { name: 'Revenue', value: '$405,091.00', change: '+4.75%', changeType: 'positive' },
  { name: 'Overdue invoices', value: '$12,787.00', change: '+54.02%', changeType: 'negative' },
  { name: 'Outstanding invoices', value: '$245,988.00', change: '-1.39%', changeType: 'positive' },
  { name: 'Expenses', value: '$30,156.00', change: '+10.18%', changeType: 'negative' },
]

const cards = [
  { name: 'Nouveaux dossiers', href: '#', icon: ScaleIcon, amount: '64 validés / 84 créés' },
  { name: 'Montant créances acquises', href: '#', icon: DocumentCheckIcon, amount: '19 500€' },
  { name: 'Argent encaissé', href: '#', icon: BanknotesIcon, amount: '0€' },
  { name: 'Taux d\'éligibilité', href: '#', icon: VariableIcon, amount: '0.74%' },
  // More items...
]
</script>
<template>
  <div>
    <header class="pt-6 pb-4 sm:pb-6">
        <div class="flex flex-wrap items-center gap-6 px-4 mx-auto max-w-7xl sm:flex-nowrap sm:px-6 lg:px-8">
          <h1 class="text-base font-semibold leading-7 text-gray-900">Indacteurs clés</h1>
          <div class="flex order-last w-full text-sm font-semibold leading-6 gap-x-8 sm:order-none sm:w-auto sm:border-l sm:border-gray-200 sm:pl-6 sm:leading-7">
            <span v-for="(item, index) in kpiNavigation" :key="item.name"
              @click="currentKpiIndex = index"
              :class="currentKpiIndex === index ? 'text-blue-600' : 'text-gray-700 cursor-pointer'">
               {{ item.name }}
            </span>
          </div>
          <!-- <a href="#" class="flex items-center px-3 py-2 ml-auto text-sm font-semibold text-white bg-blue-600 rounded-md shadow-sm gap-x-1 hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600">
            <PlusSmallIcon class="-ml-1.5 h-5 w-5" aria-hidden="true" />
            New invoice
          </a> -->
        </div>
      </header>

      <!-- Stats -->
      <div class="px-4 mx-auto sm:px-6 lg:px-8">
            <h2 class="text-lg font-medium leading-6 text-gray-900">Indicateurs clés</h2>
            <!-- <div class="flex justify-center w-full py-4 text-sm font-semibold leading-6 gap-x-8 ">
            <div v-for="(item, index) in kpiNavigation" :key="item.name"
              @click="currentKpiIndex = index"
              :class="['cursor-pointer', currentKpiIndex === index ? 'text-blue-600' : 'text-gray-700']">
               {{ item.name }}
            </div>
          </div> -->
            <div class="grid grid-cols-1 gap-5 mt-2 sm:grid-cols-2 lg:grid-cols-4">
              <!-- Card -->
              <div v-for="card in cards" :key="card.name" class="overflow-hidden bg-white rounded-lg shadow">
                <div class="p-5">
                  <div class="flex items-center">
                    <div class="flex-shrink-0">
                      <component :is="card.icon" class="w-6 h-6 text-gray-400" aria-hidden="true" />
                    </div>
                    <div class="flex-1 w-0 ml-5">
                      <dl>
                        <dt class="text-sm font-medium text-gray-500 truncate">{{ card.name }}</dt>
                        <dd>
                          <div class="text-lg font-medium text-gray-900">{{ card.amount }}</div>
                        </dd>
                      </dl>
                    </div>
                  </div>
                </div>
                <div class="px-5 py-3 bg-gray-50">
                  <div class="text-sm">
                    <a :href="card.href" class="font-medium text-cyan-700 hover:text-cyan-900">View all</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
    </div>
</template>